import {ref} from '@vue/composition-api'
export const email = ref('')
export const password = ref('')
export const captcha = ref('')
export const show1 = ref(false)